// Benefit of using useMemo/useCallback/etc as per https://kentcdodds.com/blog/usememo-and-usecallback

import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import useApigeeLabels from 'common/ApigeeLabels/hooks/useApigeeLabels';

import { IShipmentsHook } from 'services/shipments/types/shipments.types';

import DynamicLoader from 'routes/DynamicLoader';
import COLORS from 'theme/colors';
import { NowTabIcon } from '@mafc/icon';

const ShipmentLayout = DynamicLoader(() =>
  import(/* webpackChunkName: "ShipmentLayoutChunk" */ '../ShipmentLayout')
) as any;

interface Props {
  shipmentsHook: IShipmentsHook;
}

const QelecShipment: React.FC<Props> = ({ shipmentsHook }) => {
  const { totalShipmentCount, qelec } = shipmentsHook;

  const { t } = useTranslation();
  const { shipmentQelec: shipmentLabel } = useApigeeLabels();

  const deliveryMsg =
    qelec.deliverySlot && qelec.deliverySlot.deliveryMessage
      ? `${t('shipmentLayout.deliveryIn')} ${qelec.deliverySlot.deliveryMessage}`
      : t('shipmentLayout.delivery120min');

  return (
    <>
      {!!(qelec && qelec.entries && qelec.entries.length) && (
        <ShipmentLayout
          shipmentTotal={qelec.shipmentTotal}
          entries={qelec.entries}
          deliveryFee={qelec.shipmentDeliveryFee}
          currentShipmentCount={qelec.currentShipmentCount}
          totalShipmentCount={totalShipmentCount}
          entriesCount={qelec.entries.length}
          deliveryHeading={deliveryMsg}
          deliveryHeadingIcon={<NowTabIcon size="custom" width="24px" fill={COLORS.BLACK} />}
          isExpressShipment
          shipmentName={shipmentLabel}
        />
      )}
    </>
  );
};

export default memo(QelecShipment);
